module.exports = __webpack_public_path__ + "static/PP7s-01a9014e2adbc150cfbcf78ee5cb40fb.jpg";